export enum ESubProject {
	BOOM = 'boom',
	SHARE = 'share',
}
